var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncomeNudgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6979",
    "data-name": "Group 6979",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1041",
    "data-name": "Ellipse 1041",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6978",
    "data-name": "Group 6978",
    transform: "translate(2.816 5.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6976",
    "data-name": "Group 6976",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M212.057,448.741c.052.08.143.051.214.07a2.616,2.616,0,0,1,2,2.545q0,.836,0,1.671a.869.869,0,1,1-1.735,0c0-.42,0-.839,0-1.274-.092.015-.13.09-.181.14q-1.545,1.54-3.086,3.084a2.613,2.613,0,0,1-3.875.01.869.869,0,0,0-1.352.007q-2.786,2.785-5.569,5.572a.9.9,0,0,1-.916.3.863.863,0,0,1-.454-1.384,1.791,1.791,0,0,1,.133-.143l5.571-5.571a2.624,2.624,0,0,1,3.828,0,.873.873,0,0,0,1.383,0c1.085-1.083,2.168-2.167,3.29-3.289h-.916c-.138,0-.275,0-.413,0a.867.867,0,0,1-.323-1.689c.027-.011.056-.01.059-.047Z",
    transform: "translate(-196.905 -448.741)",
    fill: "#d35e0f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6977",
    "data-name": "Group 6977",
    transform: "translate(2.898 1.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1040",
    "data-name": "Ellipse 1040",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#d35e0f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.274,
    cy: 5.274,
    r: 5.274,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.274,
    cy: 5.274,
    r: 4.774,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Return_of_Premium",
    "data-name": "Return of Premium",
    transform: "translate(3.694 2.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6976-2",
    "data-name": "Group 6976",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M13.024,8.178a.162.162,0,0,1,.07.153c0,.094,0,.189,0,.284s-.044.15-.154.151h-.707c-.017,0-.04-.01-.048.009s.012.028.021.041a1.1,1.1,0,0,1,.165.376c.012.051.036.065.086.064.16,0,.321,0,.481,0a.243.243,0,0,1,.09.013.117.117,0,0,1,.073.119c0,.111,0,.221,0,.332,0,.091-.046.128-.138.128-.17,0-.34,0-.51,0-.039,0-.056.011-.064.051a1.285,1.285,0,0,1-.337.669,1.515,1.515,0,0,1-.568.367,2.345,2.345,0,0,1-.493.118l.164.183c.49.536.95,1.1,1.412,1.659a.127.127,0,0,1,.037.144.108.108,0,0,1-.1.071h-.688a.121.121,0,0,1-.1-.048q-.4-.475-.806-.949t-.818-.92c-.168-.183-.146-.124-.148-.371,0-.08,0-.161,0-.241,0-.107.047-.15.154-.151.184,0,.368.007.553-.009a1.231,1.231,0,0,0,.662-.218.631.631,0,0,0,.221-.3c.017-.049.016-.051-.036-.051H10.1a.2.2,0,0,1-.085-.009.1.1,0,0,1-.065-.083,2.146,2.146,0,0,1,0-.393.1.1,0,0,1,.1-.1.455.455,0,0,1,.072,0h1.323c.038,0,.048-.01.025-.044a.605.605,0,0,0-.214-.2,1.2,1.2,0,0,0-.488-.132c-.221-.018-.443-.006-.664-.009-.119,0-.163-.043-.163-.162s0-.256,0-.385a.145.145,0,0,1,.077-.148Z",
    transform: "translate(-9.942 -8.178)",
    fill: "#053c6d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeNudgeIcon);
export default __webpack_public_path__ + "static/media/IncomeNudgeIcon.275ef77f6aec1c2c67a9860c82faa9cc.svg";
export { ForwardRef as ReactComponent };